export const renderBodyContent = (content) => {
    const renderRichText = (children) =>
      children.map((c, j) => {
        let style = {};
        if (c.bold) style.fontWeight = "bold";
        if (c.italic) style.fontStyle = "italic";
        if (c.underline) style.textDecoration = "underline";
  
        return (
          <span key={j} style={style}>
            {c.text}
          </span>
        );
      });
  
    return content.map((item, index) => {
      switch (item.__component) {
        case "body-content.body-heading":
            const headingId = `heading-${index}`;
            return <h2 id={headingId} key={index}>{item.h2_heading}</h2>;
  
        case "body-content.body-description":
          return (
            <div key={index} className="body-description">
              {item.content?.map((p, i) => {
                switch (p.type) {
                  case "paragraph":
                    return <p key={i}>{renderRichText(p.children)}</p>;
                  case "bulleted-list":
                    return (
                      <ul key={i}>
                        {p.children?.map((li, liIndex) => (
                          <li key={liIndex}>{renderRichText(li.children)}</li>
                        ))}
                      </ul>
                    );
                  case "numbered-list":
                    return (
                      <ol key={i}>
                        {p.children?.map((li, liIndex) => (
                          <li key={liIndex}>{renderRichText(li.children)}</li>
                        ))}
                      </ol>
                    );
                  default:
                    return <p key={i}>{renderRichText(p.children)}</p>;
                }
              })}
            </div>
          );
  
        case "body-content.body-image":
          const imageUrl = item.images?.[0]?.url;
          return imageUrl ? (
            <img
              key={index}
              className="img-fluid identity_1 identity_31"
              src={`https://cms.rentid.io/admin${imageUrl}`}
              alt={item.images?.[0]?.alternativeText || "rent id"}
            />
          ) : null;
  
        default:
          return null;
      }
    });
  };
  